import { render } from "./NewDisabilityPage.vue?vue&type=template&id=385fd519&scoped=true"
import script from "./NewDisabilityPage.vue?vue&type=script&lang=js"
export * from "./NewDisabilityPage.vue?vue&type=script&lang=js"

import "./NewDisabilityPage.vue?vue&type=style&index=0&id=385fd519&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385fd519"]])

export default __exports__